module.exports = __webpack_public_path__ + "img/currency.e23fe303.png";